import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Accordion,
  Card,
  FormControl,
  Form,
  CardGroup,
  CardDeck,
  Nav,
} from "react-bootstrap";
import api from "../../api";
import axios from "axios";
import Switch from "react-switch";

export default class Channels extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _id: "trythispizza",
      isLoading: false,
      biz: [],
      biz_channels: [],
    };
  }

  componentDidMount() {
    api.getBusinessById(this.state._id).then(
      (res) => {
        console.log("Business:", res);
        let biz_data = res.data.data;
        this.setState({ biz: biz_data, biz_channels: biz_data.channels });
        console.log("Business", biz_data);
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  changeBotStatus = async (status, index) => {
    this.state.biz_channels[index].enabled = !status;
    this.setState({ biz_channels: this.state.biz_channels });

    var payload = { channels: this.state.biz_channels };

    api.updateBusinessByID(this.state._id, payload).then(
      (res) => {
        console.log("Response:", res);
        alert("Channels updated");
        window.location.reload();
      },
      (error) => {
        console.log("error", error);
        alert(error);
      }
    );
  };

  render() {
    const { biz_channels, biz } = this.state;

    return (
      <div className="row w-100 mx-0">
      <div className="col-lg-6 mx-auto">
        <h4 className="text-center">Channels</h4>
        <Card className="text-left py-5 px-4 px-sm-5">
          <Card.Body>
            <Card.Text>
              {biz_channels.map((chan, index) => (
                <Row className="">
                  <Col sm="auto">
                    <label className="text-muted">{chan.title}</label>
                  </Col>
                  <Col>
                    <div className="float-right">
                      <label className="switch">
                        <input
                          type="checkbox"
                          defaultChecked={chan.enabled}
                          onChange={() =>
                            this.changeBotStatus(chan.enabled, index)
                          }
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                  </Col>
                </Row>
              ))}
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      </div>
    );
  }
}
